module.exports = __webpack_public_path__ + "img/faq_jp.cd12b27.jpg";